import {BAR, SALON} from "@/modules/delivery/constants/OrderOrigin";
import BaseOrderService from "@/modules/delivery/core/services/BaseOrderService";

class ContactService extends BaseOrderService{
    constructor(order, settings, categoryService) {
        super(order, settings, categoryService);
        this.className = 'ContactService';
    }

    setOrderContact({name, phone, email, observations}){
        this.order.contact = {
            name: name,
            phone: phone,
            email: email,
            observations: observations
        }
    }

    isValidName(value) {
        return !!(value && value.trim()) && /^[A-Za-zÀ-ÖØ-öø-ÿÑñ ]+$/.test(value)
    }

    isValidPhone(value) {
        return /^(?!0)(?!15)\d{10}$/.test(value || '')
    }

    isValidEmail(value) {
        const email = (value || '').trim()
        return email === '' || /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)
    }

    get isReady() {
        const contact = this.order.contact

        if (!this.isValidName(contact.name)) {
            return false
        }

        if (this.order.origin !== SALON && !this.isValidPhone(contact.phone)) {
            return false
        }

        if (this.order.origin === SALON && contact.phone && !this.isValidPhone(contact.phone)) {
            return false
        }

        if (this.order.origin !== BAR && this.order.origin !== SALON && !(contact.email || '').trim()) {
            return false
        }

        if (!this.isValidEmail(contact.email)) {
            return false
        }

        return true
    }

    clear() {
        this.name = '';
        this.phone = '';
        this.email = '';
        this.observations = '';
    }
}

export default ContactService;
